import { Box } from "@chakra-ui/react";
import { colors, HLine, HStack, VStack } from "goi_common";
import React from "react";

export default function HospiceReviewSection() {
  return (
    <Box width="100%" padding="40px 24px 0px">
      <HStack gap={6}>
        <span className="button2 gray900">전체 후기</span>
        <span className="button2 orange700">0</span>
      </HStack>
      <HLine width="100%" color={colors.gray300} margin="12px 0 0" />

      <VStack
        width="100%"
        height="200px"
        justifyContent="center"
        alignItems="center"
      >
        <div className="body3_r gray500" css={{ textAlign: "center" }}>
          후기 기능은 <br />
          준비 중입니다
        </div>
      </VStack>
    </Box>
  );
}
